import {
  format,
  parseISO,
  isValid,
  differenceInDays,
  addDays,
  isPast,
  parse,
  getHours,
  getMinutes,
  startOfDay,
  compareAsc,
} from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import i18n from '../../../app/i18n';

export const formatTime = ({ hour, timezone }) => {
  const time = `${((hour + 11) % 12) + 1}:00`;
  const meridiem = `${hour < 12 || hour === 24 ? 'AM' : 'PM'}`;
  const label = `${time} ${meridiem} ${timezone}`;
  return label;
};

export const timeOptions = timezone => {
  return [...Array(25).keys()].slice(1).map(hour => {
    return { value: hour, label: formatTime({ hour, timezone }) };
  });
};

const DEFAULT_FALLBACK = i18n.t('posts:unscheduledPost');
const DATE_FORMAT = 'MMMM d, yyyy';

export const formatDate = (date, dateFormat = DATE_FORMAT) =>
  format(date, dateFormat);

export const parseDate = (
  date,
  dateFallback = DEFAULT_FALLBACK,
  dateFormat,
) => {
  const dateISO = parseISO(date);
  return isValid(dateISO) ? formatDate(dateISO, dateFormat) : dateFallback;
};

export const getDifferenceInDays = (reminderDate, publishDate) => {
  const reminderISO = parseISO(reminderDate);
  const publishISO = parseISO(publishDate);

  if (!isValid(reminderISO) || !isValid(publishISO)) return 0;

  return differenceInDays(reminderISO, publishISO);
};

export const getLiveReminderDate = (reminderDate, publishDate) => {
  if (!reminderDate) return null;

  const diff = getDifferenceInDays(reminderDate, publishDate);

  return formatDate(addDays(new Date(), diff), 'yyyy-MM-dd');
};

export const dateHasPassed = (publishDate, sendTime, timezone) => {
  const inputTimeStr = `${publishDate} ${sendTime}`;
  const inputTime = parse(inputTimeStr, 'yyyy-MM-dd hh:mm a', new Date(), {
    timeZone: timezone,
  });

  return isPast(inputTime);
};

export const getZonedDate = timezone => {
  return startOfDay(utcToZonedTime(new Date(), timezone));
};

export const isTodayInZone = (timezone, date) => {
  const dateISO = parseISO(date);
  const parsedDate = isValid(dateISO) ? dateISO : date;

  return compareAsc(getZonedDate(timezone), parsedDate) === 0;
};

export const nextAvailableHour = timezone => {
  const zonedTime = utcToZonedTime(new Date(), timezone);
  const hour = getHours(zonedTime);
  const minute = getMinutes(zonedTime);

  if (hour >= 23) return 24;

  if (minute === 0) {
    return hour === 22 ? 23 : hour + 1;
  }

  return hour === 22 ? 24 : hour + 2;
};

export const currentDayTimeOptions = (abbrTimzone, timezone) => {
  const nextHour = nextAvailableHour(timezone);

  return timeOptions(abbrTimzone).filter(time => {
    return time.value >= nextHour && time.value < 24;
  });
};
